import { render, staticRenderFns } from "./canvasLoader.vue?vue&type=template&id=dbdbe192&scoped=true&lang=pug&"
import script from "./canvasLoader.vue?vue&type=script&lang=js&"
export * from "./canvasLoader.vue?vue&type=script&lang=js&"
import style0 from "./canvasLoader.vue?vue&type=style&index=0&id=dbdbe192&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdbe192",
  null
  
)

export default component.exports